import { useTranslation } from "react-i18next";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import ScrollReveal from "@/components/common/ScrollReveal";
import SectionHeading from "@/components/common/SectionHeading";
import { FileText, Landmark, Search, TrendingUp, Users, Wallet, ClipboardList, Package, ArrowRight } from "lucide-react";
import { Link } from "@/lib/link";
import { Button } from "@/components/ui/button";

const solutions = [
    { Icon: Search, tKey: "solutionsPage.modules.buyerSupplier.title", dKey: "solutionsPage.modules.buyerSupplier.description" },
    { Icon: FileText, tKey: "solutionsPage.modules.documentation.title", dKey: "solutionsPage.modules.documentation.description" },
    { Icon: ClipboardList, tKey: "solutionsPage.modules.compliance.title", dKey: "solutionsPage.modules.compliance.description" },
    { Icon: TrendingUp, tKey: "solutionsPage.modules.marketResearch.title", dKey: "solutionsPage.modules.marketResearch.description" },
    { Icon: Wallet, tKey: "solutionsPage.modules.pricing.title", dKey: "solutionsPage.modules.pricing.description" },
    { Icon: Package, tKey: "solutionsPage.modules.shipping.title", dKey: "solutionsPage.modules.shipping.description" },
    { Icon: Landmark, tKey: "solutionsPage.modules.tradeFinance.title", dKey: "solutionsPage.modules.tradeFinance.description" },
    { Icon: Users, tKey: "solutionsPage.modules.registration.title", dKey: "solutionsPage.modules.registration.description" },
];

export default function ExportSolutions() {
    const { t } = useTranslation();
    return (
        <>
            <SEO
                title="Export Solutions — Consulting, Docs, Compliance, Shipping | Exportfy.world"
                description="End-to-end export solutions: consulting, documentation, compliance, market research, buyer/supplier identification, pricing, shipping, trade finance guidance, and export registration."
                path="/export-solutions"
            />
            <PageHero
                eyebrow={t("solutionsPage.hero.eyebrow")}
                title={t("solutionsPage.hero.title")}
                subtitle={t("solutionsPage.hero.subtitle")}
            />
            <section className="section-y">
                <div className="container-x">
                    <ScrollReveal><SectionHeading eyebrow={t("solutionsPage.modules.eyebrow")} title={t("solutionsPage.modules.title")} subtitle={t("solutionsPage.modules.subtitle")} /></ScrollReveal>
                    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                        {solutions.map(({ Icon, tKey, dKey }, i) => (
                            <ScrollReveal key={tKey} delay={i * 40}>
                                <div className="bg-white border border-slate-200 rounded-2xl p-6 h-full hover:shadow-[0_20px_40px_rgba(10,37,64,0.08)] hover:-translate-y-0.5 transition-all">
                                    <div className="w-11 h-11 rounded-xl bg-[#0A2540] flex items-center justify-center text-white"><Icon className="w-5 h-5" strokeWidth={1.75} /></div>
                                    <div className="mt-5 font-bold text-lg text-[#0A2540]">{t(tKey)}</div>
                                    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{t(dKey)}</p>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </div>
            </section>
            <section className="section-y bg-[#0A2540] text-white">
                <div className="container-x flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                    <div>
                        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{t("solutionsPage.audit.title")}</h2>
                        <p className="mt-3 text-white/70 max-w-2xl">{t("solutionsPage.audit.description")}</p>
                    </div>
                    <Link to="/consultation"><Button className="rounded-full bg-white text-[#0A2540] hover:bg-slate-100 px-7 py-6 font-semibold">{t("solutionsPage.audit.button")} <ArrowRight className="ml-2 w-4 h-4" /></Button></Link>
                </div>
            </section>
        </>
    );
}
